import { Loader2 } from 'lucide-react';

interface LoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  variant?: 'default' | 'fullscreen' | 'inline';
  className?: string;
}

const Loader = ({ 
  size = 'md', 
  text, 
  variant = 'default',
  className = '' 
}: LoaderProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  };

  const loaderElement = (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2 className={`${sizeClasses[size]} text-green-600 dark:text-green-400 animate-spin`} />
      {text && (
        <span className={`ml-3 ${textSizes[size]} text-gray-600 dark:text-gray-300`}>
          {text}
        </span>
      )}
    </div>
  );

  if (variant === 'fullscreen') {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className={`${sizeClasses[size]} text-green-600 dark:text-green-400 animate-spin mx-auto mb-4`} />
          {text && (
            <p className={`${textSizes[size]} text-gray-600 dark:text-gray-300`}>
              {text}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (variant === 'inline') {
    return (
      <div className={`inline-flex items-center ${className}`}>
        <Loader2 className={`${sizeClasses[size]} text-green-600 dark:text-green-400 animate-spin`} />
        {text && (
          <span className={`ml-2 ${textSizes[size]} text-gray-600 dark:text-gray-300`}>
            {text}
          </span>
        )}
      </div>
    );
  }

  return loaderElement;
};

export default Loader; 